const generateRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min);
}

const getRandom = (value) => {
    return value[Math.floor(Math.random() * value.length)];
}

const randomWithProbabilities = (data) => {
    let random = Math.floor(Math.random() * 100);
    for (let prob in data) {
        if (prob >= random) {
            return data[prob];
        }
    }
}

const formatTime = (seconds) => {
    // Minutes
    var minutes = Math.floor(seconds / 60);
    // Seconds
    var partInSeconds = seconds % 60;
    // Adds left zeros to seconds
    partInSeconds = partInSeconds.toString().padStart(2, '0');
    // Returns formated time
    return `${minutes}:${partInSeconds}`;
}

const getTimestampInSeconds = () => {
    return Math.floor(Date.now() / 1000)
}

export { generateRandomNumber, getRandom, randomWithProbabilities, formatTime, getTimestampInSeconds };